import { KEY_CODES, useScopedSelector } from 'ia-react-core';
import React, { ChangeEvent, FC, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { SecuredMessagingState } from '../../../../../../interfaces/SecuredMessagingState';
import { selectAllMessages } from '../../../../SecuredMessagingPage.actions';
import {
  StyledMessagesHeaderWithoutText,
  StyledTableCellLeft,
  StyledTableCellRight,
  StyledTableHead,
  StyledTableRow,
  StyledCheckBox,
} from '../../../../SecuredMessagingPage.styles';

export interface MessagesTableHeaderProps {
  sentMessages: boolean;
}

const MessagesTableHeader: FC<MessagesTableHeaderProps> = ({ sentMessages }) => {
  const { t } = useTranslation('SecureMessagingPage');
  const dispatch = useDispatch();

  const messages = useScopedSelector((state: SecuredMessagingState) => state.messages?.data || []);
  const selectedMessages: number[] = useScopedSelector((state: SecuredMessagingState) => state.selectedMessages);
  const selectedCount = useMemo(() => messages.filter(({ id: messageId }) => selectedMessages?.includes(messageId)).length, [selectedMessages, messages]);
  const checked = selectedCount === messages.length;
  const indeterminate = selectedCount > 0 && selectedCount < messages.length;

  const handleKeyDown = useCallback((event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event?.keyCode === KEY_CODES.ENTER) {
      dispatch(selectAllMessages(!event.currentTarget.checked));
    }
  }, [dispatch]);

  return (
    <StyledTableHead transparent>
      <StyledTableRow>
        <StyledMessagesHeaderWithoutText><StyledCheckBox
          aria-label={t('labelCheckboxSelectAll')}
          indeterminate={indeterminate}
          checked={checked}
          onChange={(event: ChangeEvent<HTMLInputElement>) => { dispatch(selectAllMessages(event.target.checked)); }}
          onKeyDown={handleKeyDown}
        />
        </StyledMessagesHeaderWithoutText>
        <StyledTableCellLeft>{t('headerObject')}</StyledTableCellLeft>
        <StyledTableCellLeft>{t('headerSubject')}</StyledTableCellLeft>
        <StyledMessagesHeaderWithoutText />
        <StyledTableCellRight>{sentMessages ? t('headerSent') : t('headerReceived')}</StyledTableCellRight>
      </StyledTableRow>
    </StyledTableHead>
  );
};

export default MessagesTableHeader;
